// NIGHT-DIRECTSTAFF-2026-10-22 §14: desktop keyboard. j / k move through the list on screen, Enter opens the row, r focuses
// the compose box, Esc closes the open box, / focuses search, ? shows the list of keys. NEVER on a phone (a touch device or a
// narrow window) and NEVER while typing in a field, a select or a contenteditable. Modifier keys (Ctrl / Cmd / Alt) pass
// through untouched. Pure decision here; App does the DOM.
// NIGHT-DIRECTSTAFF-2026-10-25b §3: + "g then a letter" to go somewhere -- g t Today, g n Needs a human, g r Reviews (within 1.5 s
// of the g; a plain r is still Reply). / is the one search box (everywhere).
export const KEYS = [['g t', 'Go to Today'], ['g n', 'Go to Needs a human'], ['g r', 'Go to Reviews'], ['/', 'Search everywhere'],
  ['j', 'Next row'], ['k', 'Previous row'], ['Enter', 'Open the row'], ['r', 'Reply: focus the compose box'], ['Esc', 'Close the box'], ['?', 'This list']];
export const CHORD_MS = 1500;
export const GO = { t: 'today', n: 'needs', r: 'reviews' };

export function isDesktop(win = typeof window !== 'undefined' ? window : null) {
  if (!win) return false;
  try { return win.innerWidth > 900 && !!(win.matchMedia && win.matchMedia('(pointer: fine)').matches); } catch { return false; }
}
const TYPING = /^(INPUT|TEXTAREA|SELECT)$/;
export const isTyping = (el) => !!el && (TYPING.test(el.tagName || '') || el.isContentEditable === true);

/** keydown event + where focus is -> the action name, or null (do nothing; let the browser have it). */
export function actionFor(e, { desktop = true, active = null, gAt = 0, now = Date.now() } = {}) {
  if (!desktop || !e || e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey) return null;
  if (e.key === 'Escape') return 'close';                       // Esc works from inside a field too (it leaves it)
  if (isTyping(active)) return null;
  if (gAt && now - gAt <= CHORD_MS && GO[e.key]) return `go:${GO[e.key]}`;   // the second key of "g t" / "g n" / "g r"
  if (e.key === 'g') return 'chord';
  switch (e.key) {
    case 'j': return 'next';
    case 'k': return 'prev';
    case 'Enter': return 'open';
    case 'r': return 'reply';
    case '/': return 'search';
    case '?': return 'help';
    default: return null;
  }
}

/** The new row index after next / prev (clamped; -1 = none yet). */
export function moveIndex(i, action, count) {
  if (!count) return -1;
  if (action === 'next') return Math.min(count - 1, i < 0 ? 0 : i + 1);
  if (action === 'prev') return Math.max(0, i < 0 ? 0 : i - 1);
  return i;
}
